import React, { useEffect, useState } from 'react';
import { CiCalendarDate } from 'react-icons/ci';
import { IoIosAddCircle, IoIosArrowRoundBack } from 'react-icons/io';
import { IoIosArrowRoundForward } from 'react-icons/io';

import './Toolbar.scss';
import { MultiSelect } from '../../MultiSelect/MultiSelect';
import { User } from 'types/User';
import { Button } from 'components/Button/Button';
import { FaPlus } from 'react-icons/fa6';
import arrow from 'assets/images/icons/arrow.svg';
import { Loader } from 'components/Loader/Loader';

interface ToolbarProps {
    usersFilter: any;
    setUsersFilter: any;
    usersList: User[];
    colors: string[];
    onNavigate: (view: string) => void;
    onView: (view: string) => void;
    view: any,
    label: string;
    setOpenCreateEventModal: (open: boolean) => void;
    isLoading: boolean;
}

export const Toolbar: React.FC<ToolbarProps> = ({
    usersFilter,
    setUsersFilter,
    usersList,
    colors,
    view,
    onNavigate,
    onView,
    label,
    setOpenCreateEventModal,
    isLoading
}) => {

    const getMultiValueStyles = () => {
        const styleRules = colors
            .map(
                (color, index) => `
            div[class$="-control"] [class$="-multiValue"]:nth-of-type(${index + 1}) {
                background-color: ${color} !important;
            }        `
            )
            .join('\n');

        const styleElement = document.createElement('style');
        styleElement.textContent = styleRules;
        document.head.appendChild(styleElement);

        return () => {
            document.head.removeChild(styleElement);
        };
    };

    React.useEffect(() => {
        const cleanup = getMultiValueStyles();
        return cleanup;
    }, [colors]);

    return (
        <div className="toolbar">
            <div className="top">
                <div className="left">
                    <Button
                        onClick={() => setOpenCreateEventModal(true)}
                        variant="light"
                        label="Ajouter un évènement"
                        icon={<FaPlus />}
                        iconBefore
                    />
                </div>
                <div className="right">
                    <span className="date-label">{label}</span>
                    <img src={arrow} alt="arrow-prev" onClick={() => onNavigate('PREV')} className="toolbar-icon" />
                    <span onClick={() => onNavigate('TODAY')} className="today-label">
                        Aujourd'hui
                    </span>
                    <img src={arrow} alt="arrow-next" onClick={() => onNavigate('NEXT')} className="toolbar-icon reverse" />
                </div>
            </div>
            <div className="bottom">
                <div className="left">
                    <span className="agenda-label">Agenda de :</span>
                    <div className="multiselect-container" style={{ position: 'relative', zIndex: 100 }}>
                        <MultiSelect name="users" labelKey='fullname' placeholder="Filtrer par utilisateur" values={usersFilter} update={setUsersFilter} options={usersList} colors={colors} />
                    </div>
                    {isLoading && <Loader className="toolbar-loader" small />}
                </div>
                <div className="right">
                    <span className={`view-label ${view === 'day' ? 'selected' : ''}`} onClick={() => onView('day')}>
                        Jour
                    </span>
                    <span className={`view-label ${view === 'week' ? 'selected' : ''}`} onClick={() => onView('week')}>
                        Semaine
                    </span>
                    <span className={`view-label ${view === 'month' ? 'selected' : ''}`} onClick={() => onView('month')}>
                        Mois
                    </span>
                    {/*<span
                        className={`view-label ${view === 'agenda' ? 'selected' : ''}`}
                        onClick={() => onView('agenda')}
                    >
                        Récapitulatif
                    </span>*/}
                </div>
            </div>
        </div>
    );
};
